import { Pipe, PipeTransform } from '@angular/core';

import { AddressConstants } from '../../modules/address/address.constants';

@Pipe({
	name: 'statelabel',
})
export class StateLabelPipe implements PipeTransform {
	transform(value: string): string {
		const label: string | undefined = AddressConstants.ufLabels.find(
			(o) => o.uf === value,
		)!.label;

		if (!label) {
			return '';
		}

		return label;
	}
}
